import { render, staticRenderFns } from "./AwsSaffronTrend.vue?vue&type=template&id=3d5330c6&scoped=true&"
import script from "./AwsSaffronTrend.vue?vue&type=script&lang=js&"
export * from "./AwsSaffronTrend.vue?vue&type=script&lang=js&"
import style0 from "./AwsSaffronTrend.vue?vue&type=style&index=0&id=3d5330c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5330c6",
  null
  
)

export default component.exports